if (!customElements.get('video-player')) {
  class VideoPlayer extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.video = this.querySelector('video');
      this.mobile_video = this.querySelector('[data-mobile-video]');
      this.video.querySelector('img')?.setAttribute('alt', 'video player poster image.');
      const progressBarInner = this.querySelector('[data-progress-bar-inner]');
      const mediaQuery = window.matchMedia('(min-width: 768px)');

      mediaQuery.addEventListener('change', () => {
        this.handleBreakpointChange(this.video, this.mobile_video);
      });

      this.handleBreakpointChange(this.video, this.mobile_video);
      
      window.addEventListener('load', () => {
        this.video = this.querySelector('video');
        
        if ((Number(this.video.webkitAudioDecodedByteCount) === 0) || Number(this.video.audioTracks?.length) === 0) {
          this.querySelectorAll('[data-action="mute"], [data-action="unmute"]').forEach(el => el.remove());
        }
      });
      
      this.video.addEventListener("timeupdate", () => {
        let curr = (this.video.currentTime / this.video.duration) * 100
        if (!progressBarInner) return;
        progressBarInner.style.width = `${curr}%`
      });
      
      this.video.addEventListener('ended', () => {
        this.removeAttribute('data-state');
        this.video.pause();
        this.video.load();
        if (!progressBarInner) return;
        progressBarInner.style.width = null;
      });
      
      this.addEventListener('click', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const { action } = clickedElement.dataset;
                  
        console.log(action, this.video.muted);
        
        switch (action) {
          case 'play':
            this.video.play();
            this.setAttribute('data-state', 'playing');
          break;
          case 'pause':
            this.video.pause();
            this.setAttribute('data-state', 'paused');
          break;
          case 'mute':
            e.preventDefault();
            if (window.innerWidth < 768 && this.mobile_video) {
              this.mobile_video.muted = true;
            } else {
              this.video.muted = true;
            }
            
            this.removeAttribute('data-unmuted');
          break;
          case 'unmute':
            e.preventDefault();
            if (window.innerWidth < 768 && this.mobile_video) {
              this.mobile_video.muted = false;
            } else {
              this.video.muted = false;
            }
          
            this.setAttribute('data-unmuted', true);
          break;
          default: break;
        }
      });
    }

    handleBreakpointChange(video, mobile_video) {
      video.muted = true;

      if (mobile_video) mobile_video.muted = true;

      this.removeAttribute('data-unmuted');
    }
  }
  
  customElements.define('video-player', VideoPlayer);
}
